<template>
    <div class="px-sm-0 px-2">
        <v-checkbox v-model="form.marketingAgreement" :rules="[rules.required]">
            <template v-slot:label>
                <div>
                    Přečetl/a jsem si
                        <template>
                            <a
                                    target="_blank"
                                    href="http://vuetifyjs.com"
                                    @click.stop
                            >Obchodní podmínky</a>
                        </template>
                    a souhlasím s nimi
                </div>
            </template>
        </v-checkbox>
        <v-btn block :loading="loading" :disabled="loading" color="primary" depressed tile large @click="submit($event)">Objednat</v-btn>
    </div>
</template>

<script>
    export default {
        name: 'PlaceOrder',
        props: ['form', 'loading'],
        data () {
            return {
                rules: window.validationRules.getRules()
            }
        },
        methods: {
            submit(event) {
                this.$emit('submit', event);
            }
        }
    }
</script>
